import { render, staticRenderFns } from "./period-mall-info.vue?vue&type=template&id=1e7faca0&scoped=true"
import script from "./period-mall-info.vue?vue&type=script&lang=js"
export * from "./period-mall-info.vue?vue&type=script&lang=js"
import style0 from "./period-mall-info.vue?vue&type=style&index=0&id=1e7faca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7faca0",
  null
  
)

export default component.exports